import { createAction, props } from '@ngrx/store';

export type SubmissionActivityItem = { id: string; userId: string; createdAt: string };
export type WeightActivityItem = { id: string; userId: string; createdAt: string };
export type MealActivityItem = { id: string; userId: string; date: string; category: number };
export type InteractionMetricsRow = {
  id: string;
  date: string;
  counters: Record<string, number>;
  createdAt: string;
  updatedAt: string;
};
export type PendingInvitationRow = {
  advisorId: string;
  advisorEmail: string | null;
  advisorName: string;
  userId: string;
  userEmail: string | null;
  userName: string;
  status: 'pending';
};

export type EventLogItem = {
  id: string;
  eventType: string;
  createdAt: string;
  createdBy?: string;
};

export type EventLogRow = {
  id: string;
  eventType: string;
  createdAt: string;
  createdBy?: string;
  payload?: any;
};


export enum AdminStatisticsActionTypes {
  LoadSubmissionActivity = '[Admin Statistics] Load submission activity',
  LoadSubmissionActivitySuccess = '[Admin Statistics] Load submission activity success',
  LoadSubmissionActivityFail = '[Admin Statistics] Load submission activity fail',

  LoadWeightActivity = '[Admin Statistics] Load weight activity',
  LoadWeightActivitySuccess = '[Admin Statistics] Load weight activity success',
  LoadWeightActivityFail = '[Admin Statistics] Load weight activity fail',

  LoadMealActivity = '[Admin Statistics] Load meal activity',
  LoadMealActivitySuccess = '[Admin Statistics] Load meal activity success',
  LoadMealActivityFail = '[Admin Statistics] Load meal activity fail',

  LoadInteractionMetrics = '[Admin Statistics] Load interaction metrics',
  LoadInteractionMetricsSuccess = '[Admin Statistics] Load interaction metrics success',
  LoadInteractionMetricsFail = '[Admin Statistics] Load interaction metrics fail',

  LoadPendingInvitations = '[Admin Statistics] Load pending invitations',
  LoadPendingInvitationsSuccess = '[Admin Statistics] Load pending invitations success',
  LoadPendingInvitationsFail = '[Admin Statistics] Load pending invitations fail',

  LoadEventLogs = '[Admin Statistics] Load event logs',
  LoadEventLogsSuccess = '[Admin Statistics] Load event logs success',
  LoadEventLogsFail = '[Admin Statistics] Load event logs fail',
}

export const loadSubmissionActivity = createAction(
  AdminStatisticsActionTypes.LoadSubmissionActivity,
  props<{ dateFrom?: Date; dateTo?: Date }>()
);

export const loadSubmissionActivitySuccess = createAction(
  AdminStatisticsActionTypes.LoadSubmissionActivitySuccess,
  props<{ items: SubmissionActivityItem[] }>()
);

export const loadSubmissionActivityFail = createAction(
  AdminStatisticsActionTypes.LoadSubmissionActivityFail
);

export const loadWeightActivity = createAction(
  AdminStatisticsActionTypes.LoadWeightActivity,
  props<{ startDate?: Date; endDate?: Date }>()
);

export const loadWeightActivitySuccess = createAction(
  AdminStatisticsActionTypes.LoadWeightActivitySuccess,
  props<{ items: WeightActivityItem[] }>()
);

export const loadWeightActivityFail = createAction(
  AdminStatisticsActionTypes.LoadWeightActivityFail
);

export const loadMealActivity = createAction(
  AdminStatisticsActionTypes.LoadMealActivity,
  props<{ startDate?: Date; endDate?: Date }>()
);

export const loadMealActivitySuccess = createAction(
  AdminStatisticsActionTypes.LoadMealActivitySuccess,
  props<{ items: MealActivityItem[] }>()
);

export const loadMealActivityFail = createAction(
  AdminStatisticsActionTypes.LoadMealActivityFail
);

export const loadInteractionMetrics = createAction(
  AdminStatisticsActionTypes.LoadInteractionMetrics
);

export const loadInteractionMetricsSuccess = createAction(
  AdminStatisticsActionTypes.LoadInteractionMetricsSuccess,
  props<{ items: InteractionMetricsRow[] }>()
);

export const loadInteractionMetricsFail = createAction(
  AdminStatisticsActionTypes.LoadInteractionMetricsFail
);

export const loadPendingInvitations = createAction(
  AdminStatisticsActionTypes.LoadPendingInvitations
);

export const loadPendingInvitationsSuccess = createAction(
  AdminStatisticsActionTypes.LoadPendingInvitationsSuccess,
  props<{ items: PendingInvitationRow[] }>()
);

export const loadPendingInvitationsFail = createAction(
  AdminStatisticsActionTypes.LoadPendingInvitationsFail
);

export const loadEventLogs = createAction(
  AdminStatisticsActionTypes.LoadEventLogs,
  props<{ createdBy?: string; eventType?: string; from?: string; to?: string; skip?: number; limit?: number }>()
);

export const loadEventLogsSuccess = createAction(
  AdminStatisticsActionTypes.LoadEventLogsSuccess,
  props<{ items: EventLogItem[] }>()
);

export const loadEventLogsFail = createAction(
  AdminStatisticsActionTypes.LoadEventLogsFail
);

